import { useEffect } from 'react';

const PerformanceMonitor = () => {
    useEffect(() => {
        let lcpObserver, fidObserver, clsObserver;

        // Monitor Core Web Vitals
        if ('PerformanceObserver' in window) {
            // Largest Contentful Paint (LCP)
            lcpObserver = new PerformanceObserver((list) => {
                const entries = list.getEntries();
                const lastEntry = entries[entries.length - 1];
                console.log('LCP:', lastEntry.startTime);

                // Send to analytics if needed
                if (window.gtag) {
                    window.gtag('event', 'LCP', {
                        value: Math.round(lastEntry.startTime),
                        event_category: 'Web Vitals'
                    });
                }
            });

            try {
                lcpObserver.observe({ entryTypes: ['largest-contentful-paint'] });
            } catch (e) {
                console.warn('LCP observer failed:', e);
            }

            // First Input Delay (FID)
            fidObserver = new PerformanceObserver((list) => {
                const entries = list.getEntries();
                entries.forEach((entry) => {
                    console.log('FID:', entry.processingStart - entry.startTime);

                    if (window.gtag) {
                        window.gtag('event', 'FID', {
                            value: Math.round(entry.processingStart - entry.startTime),
                            event_category: 'Web Vitals'
                        });
                    }
                });
            });

            try {
                fidObserver.observe({ entryTypes: ['first-input'] });
            } catch (e) {
                console.warn('FID observer failed:', e);
            }

            // Cumulative Layout Shift (CLS)
            let clsValue = 0;
            clsObserver = new PerformanceObserver((list) => {
                const entries = list.getEntries();
                entries.forEach((entry) => {
                    if (!entry.hadRecentInput) {
                        clsValue += entry.value;
                        console.log('CLS:', clsValue);

                        if (window.gtag) {
                            window.gtag('event', 'CLS', {
                                value: Math.round(clsValue * 1000) / 1000,
                                event_category: 'Web Vitals'
                            });
                        }
                    }
                });
            });

            try {
                clsObserver.observe({ entryTypes: ['layout-shift'] });
            } catch (e) {
                console.warn('CLS observer failed:', e);
            }
        }

        // Monitor page load performance
        window.addEventListener('load', () => {
            setTimeout(() => {
                const navigation = performance.getEntriesByType('navigation')[0];
                if (navigation) {
                    console.log('Page Load Time:', navigation.loadEventEnd - navigation.loadEventStart);
                    console.log('DOM Content Loaded:', navigation.domContentLoadedEventEnd - navigation.domContentLoadedEventStart);
                }
            }, 0);
        });

        // Cleanup observers on unmount
        return () => {
            if (lcpObserver) lcpObserver.disconnect();
            if (fidObserver) fidObserver.disconnect();
            if (clsObserver) clsObserver.disconnect();
        };
    }, []);

    return null; // This component doesn't render anything
};

export default PerformanceMonitor; 